export class LogoutOutputApiModel {    
    constructor(init?: Partial<LogoutOutputApiModel>){
        Object.assign(this, init);
    }
}